import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "help-page-layout position-relative clinician-level-two" }
const _hoisted_2 = { class: "row-span-2" }
const _hoisted_3 = {
  key: 0,
  class: "banner-help-container"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "h-100" }
const _hoisted_7 = { class: "h-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonalHelp = _resolveComponent("PersonalHelp")!
  const _component_PersonalMessageList = _resolveComponent("PersonalMessageList")!
  const _component_PersonalTraining = _resolveComponent("PersonalTraining")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_EmployeeList = _resolveComponent("EmployeeList")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PatientList = _resolveComponent("PatientList")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", {
      class: _normalizeClass(`page-content mt-2 mx-1 mx-md-3 px-0 ${!_ctx.hasAgencyCore && !_ctx.hasHomeCare ? 'no-message-access' : ''} App__Personal`)
    }, [
      _createVNode(_component_PersonalHelp),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PersonalMessageList)
      ]),
      _createVNode(_component_PersonalTraining),
      (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("a", {
              href: _ctx.banner.link,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addLog()))
            }, [
              _createElementVNode("img", {
                src: _ctx.banner.src,
                class: "axxess-banner"
              }, null, 8 /* PROPS */, _hoisted_5)
            ], 8 /* PROPS */, _hoisted_4),
            _createElementVNode("button", {
              class: "banner-close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeBanner && _ctx.closeBanner(...args)))
            }, "X")
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("template", null, [
      _createVNode(_component_router_view),
      (_ctx.showPatients || _ctx.showEmployees)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_Dialog, {
              visible: _ctx.showEmployees,
              "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showEmployees) = $event)),
              class: "dashboard-dialog",
              position: "bottomright",
              modal: "",
              "show-header": false,
              style: { height: '100vh' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_EmployeeList, {
                    showEmployees: _ctx.showEmployees,
                    "onUpdate:showEmployees": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEmployees) = $event))
                  }, null, 8 /* PROPS */, ["showEmployees"])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["visible"]),
            _createVNode(_component_Dialog, {
              visible: _ctx.showPatients,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPatients) = $event)),
              class: "dashboard-dialog",
              position: "bottomright",
              modal: "",
              "show-header": false,
              style: { height: '100vh' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_PatientList, {
                    showPatients: _ctx.showPatients,
                    "onUpdate:showPatients": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showPatients) = $event))
                  }, null, 8 /* PROPS */, ["showPatients"])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["visible"])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}